<div class="popular-itineraries" [class.popular-itineraries--custom]="isCustomTrips">
  @if (isHeader) {
    <h2>{{ 'ABOUT_US.ITINERARIES.TITLE' | translate }}</h2>

    <div class="f-row f-between f-v-center">
      <h3>{{ 'ABOUT_US.ITINERARIES.SUBTITLE' | translate }}</h3>
      @if (showBrowseButton) {
        <div class="popular-itineraries__browse">
          <button class="btn-default btn-dark" (click)="browse.emit()">Browse</button>
        </div>
      }
    </div>
  }
  <div class="popular-itineraries__cards" appSwiper [swiperOptions]="swiperOptions">
    <button class="swiper-slide-btn swiper-slide-btn--left" (click)="scrollLeft()" [disabled]="isFirstSlide">
      <mat-icon class="angle-icon" [svgIcon]="eSvgIcons.ANGLE_DOWN"></mat-icon>
    </button>

    <div class="swiper-wrapper" [class]="swiperWrapperClass">
      @if (isFetching) {
        @for (trip of fetchingTrips; let idx = $index; track idx) {
          <div
              [class.first-slide]="idx === 0"
              class="swiper-slide">
            <div class="trip" #tripCard>
              <ngx-skeleton-loader [theme]="{height: tripCard.clientHeight + 'px', margin: 0}"></ngx-skeleton-loader>
            </div>
          </div>
        }
      } @else {
        @for (trip of trips; let idx = $index; track idx) {
          <div
              [class]="swiperSlideClass"
              [class.first-slide]="idx === 0"
              class="swiper-slide">
            <div class="trip" title="{{trips[idx].name}}"
                 [style.background-image]="'url(' + trips[idx].image_url + ')'" (click)="openTripOverview(trips[idx])">
              <a class="trip-link" [href]="trips[idx].url" (click)="ignoreLink($event)">
                <div class="trip-name">{{ trips[idx].name }}</div>
              </a>
            </div>
          </div>
        }
      }
    </div>

    <button class="swiper-slide-btn swiper-slide-btn--right" (click)="scrollRight()" [disabled]="isLastSlide">
      <mat-icon class="angle-icon" [svgIcon]="eSvgIcons.ANGLE_DOWN"></mat-icon>
    </button>
  </div>
</div>
